import { Component, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';

import { ProductItem } from '../../model/product-item';
import { WebsiteService } from '../../service/website.service';

@Component({
  selector: 'breadcrumb',
  imports: [RouterLink],
  host: {
    style: 'display: contents'
  },
  template: `
    <!-- breadcrumb -->
    <div class="bread-crumb bgwhite flex-w p-l-52 p-r-15 p-t-30 p-l-15-sm">
      <a routerLink="/" class="s-text16">
        {{website().name}}
        <i class="fa fa-angle-right m-l-8 m-r-9" aria-hidden="true"></i>
      </a>

      <a routerLink="/products" class="s-text16">
        Товари
        <i class="fa fa-angle-right m-l-8 m-r-9" aria-hidden="true"></i>
      </a>

      @if (product().category; as category) {
        <a class="s-text16" [routerLink]="'/' + category.code">
          {{category.name}}
          <i class="fa fa-angle-right m-l-8 m-r-9" aria-hidden="true"></i>
        </a>
      }

      <span class="s-text17">
        {{product().name}}
      </span>
    </div>
    `
})
export class BreadcrumbComponent {

  readonly product = input.required<ProductItem>();

  readonly website = inject(WebsiteService).current;

}
